import { FC } from 'react'
import cx from 'classnames'

import { LoginFormProps } from '../../forms/LoginForm'
import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type LoginFormBlockProps = {
  className?: string
  blockTitle: string
  leftTitle: string
  rightTitle: string
  rightDescription: string
  rightButton: ActionButtonProps
  form: LoginFormProps
}

const LoginFormBlock: FC<LoginFormBlockProps> = ({
  className,
  form,
  blockTitle,
  leftTitle,
  rightButton,
  rightDescription,
  rightTitle,
}) => {
  return (
    <SC.Block className={cx('LoginFormBlock', className)}>
      <SC.Title $centered>{blockTitle}</SC.Title>
      <SC.Wrapper>
        <SC.Left>
          <SC.Title>{leftTitle}</SC.Title>
          <SC.Form {...form} />
        </SC.Left>
        <SC.Right>
          <SC.Inner>
            <SC.Title>{rightTitle}</SC.Title>
            <SC.Description>{rightDescription}</SC.Description>
          </SC.Inner>
          <SC.Button {...rightButton} />
        </SC.Right>
      </SC.Wrapper>
    </SC.Block>
  )
}

export default LoginFormBlock
